import React from 'react'
import { KlarnaWrapper, ProductDescFooter, VariantPurchaseInfo } from './ProductForm'
import ProductCTA from '../productCTA'
import { CTA_TYPE } from '../productCTA/productCTAConstants'
import Product from '@src/quince-site-common/src/domains/Product'
import styles from './miniPDPRightContainer.module.scss'
import Button, { BUTTON_SIZE, BUTTON_TYPES } from '../button'
import * as prdFormStyles from './productForm.module.scss'

interface RightMiniPDPAddToCartType {
  hidePayLater?: boolean
  salePrice?: number
  festivalOfferPrice?: number
  type: CTA_TYPE
  onAddToCart: (isPreorder?: boolean) => void
  isAddToCartInProgress?: boolean | undefined
  selectedVariantPurchaseInfo?: VariantPurchaseInfo | undefined
  onJoinWaitList: (email?: string | undefined) => void
  showVariantAvailableInventory: boolean
  product?: Product | undefined
  shouldShow?: boolean
  hideFooter?: boolean
  isReturnable?: boolean
  setShowFullPDP?: (() => void) | ((val: boolean) => void)
  hideKlarna?: boolean
  errorMessage?: string
  inStockMsgClass?: string
}

export const RightMiniPDPAddToCart = ({
  hidePayLater,
  salePrice,
  festivalOfferPrice,
  type,
  onAddToCart,
  isAddToCartInProgress,
  selectedVariantPurchaseInfo,
  onJoinWaitList,
  showVariantAvailableInventory,
  product,
  shouldShow,
  hideFooter,
  isReturnable,
  setShowFullPDP,
  hideKlarna,
  errorMessage,
  inStockMsgClass,
}: RightMiniPDPAddToCartType) => {
  if (!shouldShow) return <></>

  return (
    <div className={styles.wrapper}>
      {!hideKlarna && (
        <KlarnaWrapper
          hidePayLater={hidePayLater}
          salePrice={salePrice}
          festivalOfferPrice={festivalOfferPrice}
          wrapperClassname={styles.klarnaWrapper}
        />
      )}
      {errorMessage && <div className={prdFormStyles.container__error_message}>{errorMessage}</div>}
      <ProductCTA
        type={type}
        onAddToCart={onAddToCart}
        isAddToCartInProgress={isAddToCartInProgress}
        selectedVariantPurchaseInfo={selectedVariantPurchaseInfo}
        onJoinWaitList={onJoinWaitList}
        showVariantAvailableInventory={showVariantAvailableInventory}
        product={product}
        inStockMsgClass={inStockMsgClass}
      />
      <Button
        className={styles.viewDetailsButtonWrapper}
        type={BUTTON_TYPES.OUTLINED}
        size={BUTTON_SIZE.LARGE}
        disabled={false}
        round={true}
        onClick={() => {
          setShowFullPDP?.(true)
        }}
      >
        view full details
      </Button>
      <ProductDescFooter hideFooter={hideFooter} isReturnable={isReturnable} product={product} />
    </div>
  )
}
